export const OrderListCardLgSkeleton: React.FC = () => (
  <div className='flex items-center justify-start gap-[10px] animate-pulse'>
    <div className='w-[5px] h-[90%] rounded-[3px] bg-skeleton' />
    <div className='grow p-4 rounded-2xl overflow-hidden hover:cursor-pointer hover:opacity-80 bg-skeleton border border-skeleton-border'>
      <div className='flex items-center justify-between'>
        <div className='grow'>
          <div className='flex items-center justify-start mb-[10px] gap-[5px]'>
            <div className='w-[15px] h-[15px] min-w-[15px] min-h-[15px] rounded-[7.5px] bg-skeleton-hi' />
            <div className='h-[1em] w-[50%] rounded-3xl bg-skeleton-hi' />
          </div>
          <div className='ml-[20px] h-[1rem] w-[60%] rounded-3xl bg-skeleton-hi' />
        </div>
        <div className='rounded-3xl h-[1.3rem] w-[25%] bg-skeleton-hi' />
      </div>
    </div>
  </div>
)
